import { render } from "./PublicLayout.vue?vue&type=template&id=255355cc&scoped=true&ts=true"
import script from "./PublicLayout.vue?vue&type=script&lang=ts"
export * from "./PublicLayout.vue?vue&type=script&lang=ts"

import "./PublicLayout.vue?vue&type=style&index=0&id=255355cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255355cc"]])

export default __exports__